<div class="container">
  <div class="modal-header">
    <h2>{{ 'experience_modal.title' | translate }}</h2>
  </div>

  <div class="work-fields">
    <app-input [size]="InputSize.LARGER" [withNoIcon]="true"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="workExperience.jobTitle"
               [placeholder]="'experience_modal.job_title_placeholder' | translate"></app-input>
    <app-input [size]="InputSize.LARGER" [withNoIcon]="true"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="workExperience.organization"
               [placeholder]="'experience_modal.company_placeholder' | translate"></app-input>
    <app-input [size]="InputSize.LARGER" [withNoIcon]="true"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="workExperience.location"
               [placeholder]="'experience_modal.location_placeholder' | translate"></app-input>
    <app-input [size]="InputSize.LARGER" [withNoIcon]="true" type="date"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="workExperience.startDate"
               [placeholder]="'experience_modal.start_date_placeholder' | translate"></app-input>
    <app-input [size]="InputSize.LARGER" [withNoIcon]="true" type="date"
               (ngModelChange)="onInputChange()"
               [state]="InputState.REGULAR" [(ngModel)]="workExperience.completionDate"
               [placeholder]="'experience_modal.completion_date_placeholder' | translate"></app-input>
    <app-input-area
      (text)="updateDescription($event)"
      class="custom-textarea"
      [placeholder]="'experience_modal.description_placeholder' | translate"
      [defaultText]="workExperience.jobDescription"
      [isEditable]="true" [withSubmit]="false"
    ></app-input-area>

  </div>

  <div *ngIf="validationErrors.requiredFields" class="error-msg">
    {{ 'education_modal.error_required_fields' | translate }}
  </div>
  <div *ngIf="validationErrors.startDateFuture" class="error-msg">
    {{ 'education_modal.error_start_date_past' | translate }}
  </div>
  <div *ngIf="validationErrors.invalidRange" class="error-msg">
    {{ 'education_modal.error_invalid_range' | translate }}
  </div>

  <div class="modal-actions">
    <div class="button-group">
      <app-button (click)="cancel()" [label]="'shared.cancel' | translate" [state]="ButtonState.REGULAR"
                  [size]="ButtonSize.LARGE" [type]="ButtonType.SECONDARY"></app-button>
      <app-button (click)="save()" [label]="'shared.save' | translate"
                  [state]="isInvalid ? ButtonState.DISABLED : ButtonState.REGULAR"
                  [size]="ButtonSize.LARGE" [type]="ButtonType.PRIMARY"></app-button>
    </div>
  </div>
</div>
